import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { StrictMode } from "react";
import * as Sentry from "@sentry/react";
import { isDev } from "config";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"; // 수정된 부분

// 카카오 SDK 초기화
const initializeKakaoSDK = () => {
  const kakaoKey = process.env.REACT_APP_KAKAO_JS_KEY;

  if (!kakaoKey) {
    console.warn("[Kakao] REACT_APP_KAKAO_JS_KEY가 설정되지 않았습니다.");
    return;
  }

  if (!window.Kakao) {
    console.warn("[Kakao] SDK가 아직 로드되지 않았습니다.");
    return;
  }

  if (!window.Kakao.isInitialized()) {
    window.Kakao.init(kakaoKey);
    console.log("[Kakao] SDK 초기화 완료:", window.Kakao.isInitialized());
  } else {
    console.log("[Kakao] SDK 이미 초기화됨");
  }
};

// DOM 로드 완료 후 초기화
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeKakaoSDK);
} else {
  initializeKakaoSDK();
}

Sentry.init({
  dsn: "https://47ff8d768160cd581fa4fafb69a77d57@o4504052882407424.ingest.sentry.io/4506102643949568",
  environment: isDev ? "dev" : "main",
  integrations: [Sentry.browserTracingIntegration()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  tracesSampleRate: 1.0,

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 0.0,

  // beforeSend hook: userId가 있으면 자동으로 추가
  beforeSend(event, hint) {
    try {
      const userStr = localStorage.getItem("user");
      if (userStr) {
        const userData = JSON.parse(userStr);
        if (userData?.userId) {
          // event에 user context 설정
          event.user = event.user || {};
          event.user.id = String(userData.userId);

          // tags에도 userId 추가
          event.tags = event.tags || {};
          event.tags.userId = String(userData.userId);
        }
      }
    } catch (e) {
      // localStorage 접근 실패 시 무시
    }
    return event;
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
